module.exports = __webpack_public_path__ + "img/title2-min.a9c1d410.png";